module.exports = "<div class=\"flex m-t-20\"><div class=\"size\"><number [fg]=\"fg\" [alt]=\"true\" field=\"qty\" label=\"Quantity\"></number></div><div class=\"layout-column c-red animated fadeIn\" *ngIf=\"product.errorInTransfer\">Provide quantity.</div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/inventory/product-qty/product-qty.component.pug
// module id = 1019
// module chunks = 0